import { Paper, Tabs } from '@mantine/core';
import { BiSupport } from 'react-icons/bi';
import { PiBriefcase } from 'react-icons/pi';
import { Redirect, Route, Switch, useLocation } from 'wouter';
import { AgentsPage } from '@/pages/products/agents/AgentsPage';
import ServicesPage from './services/ServicesPage';

export default function Products() {
  const [loc, nav] = useLocation();

  return (
    <Paper p="md" h={'100%'}>
      <Tabs
        value={loc.split('/').at(1)}
        keepMounted={false}
        onChange={(tab) => nav(`/${tab}`)}
      >
        <Tabs.List>
          <Tabs.Tab value="services" leftSection={<PiBriefcase />}>
            LegalBison Services
          </Tabs.Tab>
          <Tabs.Tab value="agents" leftSection={<BiSupport />}>
            Agents
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Switch>
        <Route path="/services" component={ServicesPage} nest />
        <Route path="/agents" component={AgentsPage} nest />
        <Route>
          <Redirect to="/services" replace={true} />
        </Route>
      </Switch>
    </Paper>
  );
}
